export class ExecuterAllTask
{
    taskId:String;
    requestId:String;
    messageText:String;
    affectationProfil:String;
    affectationUser:String;
    avis:String;
    estAccepte : boolean;
    numDossier:String;
    numeroDossierPret:String;
    dateReelMiseEnPlace:String;
    eligibleComite:boolean;
}
  